<div *appIsDesktop id="invoiceDetailsContainer">
  <ds-divider></ds-divider>

  <div id="invoiceDetails" class="table-container">
    @if (invoiceDetailsResult?.length) {
      <div id="invoiceDetailsResultContainer">
        <ds-table id="invoiceTable" mat-table [dataSource]="invoiceDetailsResult"
          [displayedColumns]="displayedColumns">
          <!-- ERP Line # -->
          <ng-container matColumnDef="erp">
            <th id="ERPLine" mat-header-cell *matHeaderCellDef>
              {{appStrings.invoice_table_erp}}
            </th>
            <td [id]="'lineNumber_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex">
              {{invoice.lineNumber}}
            </td>
          </ng-container>
          <!-- Product Number -->
          <ng-container matColumnDef="product">
            <th id="productNumberHeader" mat-header-cell *matHeaderCellDef>
              {{appStrings.invoice_table_stockNumber}}
            </th>
            <td [id]="'productNumber_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex">
              {{invoice.productNumber}}
            </td>
          </ng-container>
          <!-- Product Name -->
          <ng-container matColumnDef="productName">
            <th id="productNameHeader" mat-header-cell *matHeaderCellDef>
              {{appStrings.invoice_table_productName}}
            </th>
            <td [id]="'bpNumber_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex">
              {{invoice.bpNumber}}
            </td>
          </ng-container>
          <!-- Description -->
          <ng-container matColumnDef="description">
            <th id="descriptionHeader" mat-header-cell *matHeaderCellDef>
              {{appStrings.invoice_table_description}}
            </th>
            <td [id]="'description_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex">
              {{invoice.description}}
            </td>
          </ng-container>
          <!-- Warehouse -->
          <ng-container matColumnDef="warehouse">
            <th id="warehouseHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{appStrings.invoice_table_warehouse}}
            </th>
            <td [id]="'warehouse_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex" class="text-right">
              {{invoice.warehouse}}
            </td>
          </ng-container>
          <!-- Ship Quantity -->
          <ng-container matColumnDef="shipQuantity">
            <th id="shipQuantityHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{appStrings.invoice_table_shipQuantity}}
            </th>
            <td [id]="'shipQuantity_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex" class="text-right">
              {{invoice.shipQuantity}}
            </td>
          </ng-container>
          <!-- Back Quantity -->
          <ng-container matColumnDef="backQuantity">
            <th id="backQuantityHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{appStrings.invoice_table_backQuantity}}
            </th>
            <td [id]="'backQuantity_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex" class="text-right">
              {{invoice.backorderQuantity}}
            </td>
          </ng-container>
          <!-- Order Quantity -->
          <ng-container matColumnDef="orderQuantity">
            <th id="orderQuantityHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{appStrings.invoice_table_orderQuantity}}
            </th>
            <td [id]="'orderQuantity_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex" class="text-right">
              {{invoice.orderQuantity}}
            </td>
          </ng-container>
          <!-- Unit Price -->
          <ng-container matColumnDef="unitPrice">
            <th id="unitPriceHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{appStrings.invoice_table_unitPrice}}
            </th>
            <td [id]="'unitPrice_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex" class="text-right">
              {{invoice.unitNet | currency: currencySymbol}}
            </td>
          </ng-container>
          <!-- Total Price -->
          <ng-container matColumnDef="totalPrice">
            <th id="totalPriceHeader" mat-header-cell *matHeaderCellDef class="text-right">
              {{appStrings.invoice_table_totalPrice}}
            </th>
            <td [id]="'totalPrice_'+i" mat-cell *matCellDef="let invoice; let i=dataIndex" class="text-right">
              {{invoice.totalNet | currency: currencySymbol }}
            </td>
          </ng-container>
        </ds-table>
        <div id="paginatorContainer" class="flex-container">
          <div id="pageCountContainer" class="page-count flex-item">
            <b id="pageRangeText">{{ pageOffset + 1 }} - {{ pageOffset + totalRecords }}</b> {{appStrings.pagination_of}} <b id="totalRecordsText">{{ totalRecords }}</b>
          </div>
          @if (dataLoaded.templateValues && dataLoaded.invoiceDetails) {
            <ds-pagination
              id="invoiceDetailsPaginator"
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          }
          <div class="flex-item"></div>
        </div>
      </div>
    } @else {
      <div id="noResultsMessage">{{appStrings.noEntriesFound}}</div>
    }

  </div>
</div>

<div *appIsMobile id="invoiceDetailsContainer-mobile" class="mobile">
  <ds-divider></ds-divider>

  @if (invoiceDetailsResult?.length) {
    <div id="invoiceDetails-mobile">
      @for (invoice of invoiceDetailsResult; track invoice; let i = $index) {
        <mat-expansion-panel [id]="'invoiceDetailCard_'+i" class="mobile-card two-columns grey tall blue-border" [expanded]="false"
          >
          <mat-expansion-panel-header [id]="'invoiceDetailCardHeader_'+i" class="full-height">
            <mat-panel-title [id]="'invoice-detail-card-header-container_'+i" class="card-header-container">
              <span [id]="'invoice-detail-card-header_'+i" class="card-header">
                <span [id]="'invoice-detail-card-title_'+i" class="title">
                  #{{invoice.lineNumber}} - {{invoice.productNumber}}
                </span>
                <div [id]="'invoiceDetailCardRowHeader_'+i" class="row">
                  <div [id]="'invoiceDetailCardRowHeaderCol1_'+i" class="column full-width">
                    <typography [id]="'description_label_'+i" class="label" variant="caption-2" weight="regular">
                      {{appStrings.invoice_table_description}}
                    </typography>
                    <typography [id]="'description_'+i" variant="body-2" weight="medium">
                      {{invoice.description}}
                    </typography>
                  </div>
                </div>
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div [id]="'invoiceDetailCardContent_'+i">
            <div [id]="'invoiceDetailCardRow1_'+i" class="row">
              <div [id]="'invoiceDetailCardRow1Col1_'+i" class="column">
                <typography [id]="'warehouse_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_warehouse}}
                </typography>
                <typography [id]="'warehouse_'+i" variant="body-2" weight="medium">
                  {{invoice.warehouse || '-'}}
                </typography>
              </div>
            </div>
            <div [id]="'invoiceDetailCardRow2_'+i" class="row">
              <div [id]="'invoiceDetailCardRow2Col1_'+i" class="column">
                <typography [id]="'shipQuantity_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_shipQuantity}}
                </typography>
                <typography [id]="'shipQuantity_'+i" variant="body-2" weight="medium">
                  {{invoice.shipQuantity}}
                </typography>
              </div>
              <div [id]="'invoiceDetailCardRow2Col2_'+i" class="column">
                <typography [id]="'backQuantity_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_backQuantity}}
                </typography>
                <typography [id]="'backQuantity_'+i" variant="body-2" weight="medium">
                  {{invoice.backorderQuantity}}
                </typography>
              </div>
              <div [id]="'invoiceDetailCardRow2Col3_'+i" class="column">
                <typography [id]="'orderQuantity_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_orderQuantity}}
                </typography>
                <typography [id]="'orderQuantity_'+i" variant="body-2" weight="medium">
                  {{invoice.orderQuantity}}
                </typography>
              </div>
            </div>
            <div [id]="'invoiceDetailCardRow3_'+i" class="row">
              <div [id]="'invoiceDetailCardRow3Col1_'+i" class="column">
                <typography [id]="'unitPrice_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_unitPrice}}
                </typography>
                <typography [id]="'unitPrice_'+i" variant="body-2" weight="medium">
                  {{invoice.unitNet | currency: currencySymbol}}
                </typography>
              </div>
              <div [id]="'invoiceDetailCardRow3Col2_'+i" class="column">
                <typography [id]="'totalPrice_label_'+i" class="label" variant="caption-2" weight="regular">
                  {{appStrings.invoice_table_totalPrice}}
                </typography>
                <typography [id]="'totalPrice_'+i" variant="body-2" weight="medium">
                  {{invoice.totalNet | currency: currencySymbol}}
                </typography>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      }
      @if (totalRecords > 0) {
        <div id="paginationContainerMobile" class="flex-container">
          <div id="mobilePagination" class="pagination">
            <ds-pagination
              [totalPages]="totalPages"
              paginationDisplay="small"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
        </div>
      }
    </div>
  } @else {
    <div id="emptyInvoiceDetailsList" class="no-results">
      {{appStrings.noEntriesFound}}
    </div>
  }

</div>